module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/up_calificacion.d85fb8a9.svg";